import { Navigate } from "react-router-dom"

import { NotAllowed } from "../../../../components/PermissionGate/NotAllowed.tsx"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { getLandingProjectTab } from "../../helpers/project-visible-tabs.ts"

export function ProjectDefaultSectionRedirect() {
  const permissions = useAppSelector(
    (state) => state.auth.permissions?.codes?.projects
  )
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)

  const firstVisibleTab = getLandingProjectTab(permissions, roleId)

  if (!firstVisibleTab) return <NotAllowed />

  return <Navigate to={firstVisibleTab} replace />
}
